import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// Check if an error/rejection is from a browser extension (e.g. Give Freely)
function isFromExtension(filenameOrStack) {
  if (!filenameOrStack || typeof filenameOrStack !== 'string') return false;
  const s = filenameOrStack.toLowerCase();
  return (
    s.includes('givefreely') ||
    s.includes('chrome-extension://') ||
    s.includes('moz-extension://') ||
    s.includes('extension://')
  );
}

// Global error handler to suppress third-party script errors
window.addEventListener('error', (event) => {
  if (event.filename && isFromExtension(event.filename)) {
    event.preventDefault();
    event.stopPropagation();
    console.warn('Suppressed error from browser extension:', event.filename);
    return true;
  }
});

// Handle unhandled promise rejections (e.g. from Give Freely extension)
window.addEventListener('unhandledrejection', (event) => {
  try {
    const reason = event.reason;
    const stack = reason && (
      reason.stack ||
      reason.message ||
      (reason.error && (reason.error.stack || reason.error.message)) ||
      String(reason)
    );
    if (stack && isFromExtension(stack)) {
      event.preventDefault();
      event.stopPropagation();
      console.warn('Suppressed promise rejection from browser extension');
      return true;
    }
  } catch (_) {
    // ignore
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
